import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";
import CustomToast from "src/components/CustomToast/CustomToast";
import cmsClient from "src/services/cmsClient";

const deleteAppBrands = async (data: number[]) => {
	const url = "/homepage/admin/app-branding/delete/";

	const response = await cmsClient.delete(url, { data });

	return response.data;
};

const useDeleteFullScreenTakeoverBanners = () => {
	const queryClient = useQueryClient();

	const onSuccess = () => {
		toast.success(
			<CustomToast type="Success" message="App brands(s) have been deleted" />,
			{ hideProgressBar: true }
		);

		queryClient.invalidateQueries(["app-brand-library"]);
	};

	const onError = () => {
		toast.error(
			<CustomToast type="Error" message="Something went wrong, try again" />,
			{ hideProgressBar: true }
		);
	};

	const mutation = useMutation(deleteAppBrands, {
		onError,
		onSuccess
	});

	return mutation;
};

export default useDeleteFullScreenTakeoverBanners;
